<template>
  <div class="seccion-invitacion">
    <!-- Mariposa decorativa en el borde izquierdo -->
    <img
      src="@/assets/mariposas.png"
      alt="Mariposa decorativa"
      class="mariposa-borde"
      ref="mariposaRef"
    />

    <div class="contenido-invitacion">

      <p class="bendicion" ref="bendicionRef">
        Con la bendición de Dios y de mis Padres
      </p>

      <div class="nombres-padres" ref="nombresRef">
        <p>NORA ORTÍZ</p>
        <p>&</p>
        <p class="fallecido">
          ANGEL MATOS <i class="fas fa-cross"></i>
        </p>
      </div>

      <div class="imagen-wrapper" ref="imagenRef">
        <img src="@/assets/1.webp" alt="Quinceañera" class="imagen-ovalada" />
      </div>

      <p class="mensaje-invitacion" ref="mensajeRef">
        Con un corazón agradecido y la esperanza puesta en el, celebro el inicio de esta nueva etapa en mi vida.<br />
      </p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'InvitacionXV',
  setup() {
    const bendicionRef = ref(null);
    const nombresRef = ref(null);
    const imagenRef = ref(null);
    const mensajeRef = ref(null);
    const mariposaRef = ref(null);

    const animateOnScroll = (element, animationFn) => {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          animationFn();
          observer.unobserve(entry.target);
        }
      }, { threshold: 0.3 });
      observer.observe(element);
    };

    onMounted(() => {
      if (bendicionRef.value) {
        animateOnScroll(bendicionRef.value, () =>
          gsap.fromTo(bendicionRef.value, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 1, ease: 'power2.out' }));
      }

      if (nombresRef.value) {
        animateOnScroll(nombresRef.value, () =>
          gsap.fromTo(nombresRef.value, { opacity: 0, scale: 0.8 }, { opacity: 1, scale: 1, duration: 1.2, ease: 'back.out(1.7)' }));
      }

      if (imagenRef.value) {
        animateOnScroll(imagenRef.value, () =>
          gsap.fromTo(imagenRef.value, { opacity: 0, scale: 0.3 }, { opacity: 1, scale: 1, duration: 1.5, ease: 'elastic.out(1, 0.5)' }));
      }

      if (mensajeRef.value) {
        animateOnScroll(mensajeRef.value, () =>
          gsap.fromTo(mensajeRef.value, { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1.3, ease: 'power3.out', delay: 0.2 }));
      }

      // Animación de entrada + flotado de la mariposa
      if (mariposaRef.value) {
        animateOnScroll(mariposaRef.value, () => {
          gsap.fromTo(
            mariposaRef.value,
            { opacity: 0, x: -40, rotate: -10, scale: 0.9 },
            { opacity: 1, x: 0, rotate: 0, scale: 1, duration: 1.1, ease: 'power3.out' }
          );
          // Flotado suave continuo (aleteo)
          gsap.to(mariposaRef.value, {
            y: '+=10',
            rotate: 2,
            duration: 2.2,
            ease: 'sine.inOut',
            yoyo: true,
            repeat: -1
          });
        });
      }
    });

    return { bendicionRef, nombresRef, imagenRef, mensajeRef, mariposaRef };
  }
};
</script>

<style scoped>
.seccion-invitacion {
  padding: 60px 0px;
  background-color: #d9d2f1;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  margin-bottom: -60px;
  position: relative; /* para posicionar la mariposa dentro del borde izquierdo */
}

.contenido-invitacion {
  max-width: 500px;
  margin: 0 auto;
}

.bendicion {
  font-family: 'titulos', cursive;
  font-size: 36px;
  margin-bottom: 20px;
  letter-spacing: 1px;
  color: #333232;
  opacity: 0;
}

.nombres-padres {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  color: #2b2b2b;
  margin-bottom: 30px;
  opacity: 0;
}

.nombres-padres .fallecido i {
  margin-left: 6px;
  color: #444;
  font-size: 16px;
}

.imagen-wrapper {
  width: 300px;
  height: 360px;
  margin: 0 auto 30px;
  overflow: hidden;
  background: white;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  opacity: 0;
}

.imagen-ovalada {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mensaje-invitacion {
  font-size: 32px !important;
  line-height: 1.7;
  color: #101010;
  font-family: 'titulos', sans-serif;
  letter-spacing: 1px;
  margin-left: 0 !important;
  margin-right: 0 !important;
  opacity: 0;
}

/* --- Mariposa en el borde izquierdo --- */
.mariposa-borde {
  position: absolute;
  left: -18px;        /* “pegada” al borde izquierdo */
  top: -12%;
  width: 178px;        /* ajusta según tu PNG */
  height: auto;
  opacity: 0;         /* inicia invisible, aparece con GSAP */
  filter: drop-shadow(0 6px 10px rgba(0,0,0,0.15));
  pointer-events: none; /* evita interferir con clics/scroll */
  transform-origin: 60% 40%; /* punto de aleteo más natural */
}

@keyframes flutter {
  0%   { transform: translateY(0) rotate(0deg); }
  50%  { transform: translateY(8px) rotate(2deg); }
  100% { transform: translateY(0) rotate(0deg); }
}
.mariposa-borde { animation: flutter 2.4s ease-in-out infinite; }

</style>
